import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export function servicesBoxAnimations() {
  document.addEventListener("DOMContentLoaded", () => {
    const sec = document.querySelector(".services-box");
    if (!sec) return;

    const titleWrap = sec.querySelector(".services-box__main-title");
    if (titleWrap) {
      gsap.set(titleWrap, { opacity: 0, willChange: "opacity" });
      gsap.to(titleWrap, {
        opacity: 1,
        duration: 0.9,
        ease: "power2.out",
        scrollTrigger: {
          trigger: titleWrap,
          start: "top 80%",
          toggleActions: "play none none none",
          once: true
        },
        onComplete: () => gsap.set(titleWrap, { willChange: "auto" })
      });
    }

    const cards = sec.querySelectorAll(".service-card");
    if (!cards.length) return;

    cards.forEach((card) => {
      gsap.set(card, { opacity: 0, willChange: "opacity" });
      gsap.to(card, {
        opacity: 1,
        duration: 0.9,
        ease: "power2.out",
        scrollTrigger: {
          trigger: card,
          start: "top 80%",
          toggleActions: "play none none none",
          once: true
        },
        onComplete: () => gsap.set(card, { willChange: "auto" })
      });
    });
  });
}